// @ts-nocheck

/**
 * * `1` - Child 1 (Primary)
 * `2` - Child 2 (Secondary)
 * `3` - Child 3 (Tertiary)
 */
export type PositionIdEnum = typeof PositionIdEnum[keyof typeof PositionIdEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PositionIdEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;
